import { render, staticRenderFns } from "./CompetitionsViewForecastsList.vue?vue&type=template&id=e935aca8&scoped=true&"
import script from "./CompetitionsViewForecastsList.vue?vue&type=script&lang=js&"
export * from "./CompetitionsViewForecastsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e935aca8",
  null
  
)

export default component.exports